<template>
    <div v-if="shouldShowAds && isScreenSizeOk" :class="[paddingClass, backgroundClass, internalWrapperClass, adPosition,'rin-ad-wrapper']">

        <div v-if="isGoogleAdsEnabled" class="rin-ad-slot">
            <HideAdsBtn class="hide-ads" />
            <p class="advertisement-info"> {{ translations['shared_Ads_Label'] }}</p>
            <div v-bind:class="{ 'ad-border': isLocal }" :key="refreshKey" :style="{maxWidth: adWidth, maxHeight:adHeight}">
                <Adsense data-ad-client="ca-pub-2431348456451065"
                         :data-ad-slot="dataAdSlot"
                         :ins-style="insstyle"
                         :data-ad-format="dataAdFormat"
                         :data-full-width-responsive="dataFullWidthResponsive"
                         class="adsbygoogle">
                </Adsense>
            </div>
        </div>

    </div>
</template>

<script>
import spaEventBus from "@/app/eventBus";

import { mapGetters } from 'vuex';
import HideAdsBtn from '@/components/rin_new_design/components/GoogleAds/HideAdsButton.vue';

export default {
    name: 'AdSlot',
    props: {
        dataAdSlot: {
            type: String,
            required: true
        },
        adWidth: {
            type: String,
            required: true
        },
        adHeight: {
            type: String,
            required: true
        },
        insstyle: {
            type: String,
            default: ''
        },
        isMobileOnly: {
            type: Boolean,
            default: false
        },
        paddingClass: {
            type: String,
            default: 'padding-1rem'
        },
        backgroundClass: {
            type: String,
            default: 'no-background'
        },
        dataAdFormat: {
            type: String,
            default: ''
        },
        dataFullWidthResponsive: {
            type: String,
            default: 'no'
        },
        adPosition: {
            type: String,
            default: 'justify-center'
        }
    },
    components: {
        HideAdsBtn
    },
    data() {
        return {
            refreshKey: 1,
        }
    },
    computed: {
        ...mapGetters(['layout', 'translations', 'nomenclatures']),
        ...mapGetters('monetization', ['shouldShowAds']),

        isLocal() {
            return this.nomenclatures.Environment == 'local';
        },

        isGoogleAdsEnabled() {
            return this.nomenclatures.config.isGoogleAdsEnabled;
        },

        isScreenSizeOk() {
            return (this.isMobileOnly && this.$windowSize.isMobile) || !this.isMobileOnly;
        },

        isAutoAdFormat() {
            return this.dataAdFormat == 'auto';
        },

        internalWrapperClass() {
            if (this.isAutoAdFormat) return 'ad-min-dimensions';
            return '';
        }
    },
    mounted() {

        spaEventBus.$on('refreshGoogleAd', () => {
            this.refreshKey += 1;
        });

    }
}
</script>

<style scoped>
.advertisement-info {
    margin-bottom: 2px;
    font-size: 12px;
    color: grey;
    text-align: right;
    margin-right: 10px;
}

/*.hide-ads {
    position: absolute;
}*/

.rin-ad-wrapper {
    width: 100%;
    display: flex;
}

.justify-center{
    justify-content: center;
}

.justify-start {
    justify-content: start;
}


    .ad-border {
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        background-image: url("https://cdn.rankedin.com/images/rin_logo_sm.png");
        background-size: 100px 100px;
    }

    .padding-0 {
        padding: 0;
    }

    .padding-1rem {
        padding: 1rem;
    }

    .padding-1rem-top-bottom {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .padding-1rem-no-bottom {
        padding: 1rem 1rem 0 1rem;
    }

    .white-background {
        background-color: white;
    }

    .ad-min-dimensions {
        min-height: 100px;
        min-width: 100%;
    }
</style>